export default {
	changeMsg(state, msg) {
		state.msg = msg;
    },
    toggleAccommodationModal(state) {
        state.showAccommodationModal = !state.showAccommodationModal;
    },
};